import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkipNext10 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0001 11.3334L14.6667 8.00002L10.0001 4.66669V11.3334Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.34668 5.888C7.52487 5.88816 8.24121 6.77356 8.24121 8.30988C8.24121 9.85921 7.52487 10.7316 6.34668 10.7318C5.16829 10.7318 4.45215 9.85284 4.45215 8.30988C4.45215 6.76691 5.16829 5.888 6.34668 5.888ZM3.42285 10.6663H2.44043V6.88409H2.41406L1.33301 7.56085V6.69562L2.49902 5.95343H3.42285V10.6663ZM6.34668 6.68878C5.7998 6.68878 5.4541 7.23566 5.4541 8.30988C5.44759 9.39711 5.7998 9.92413 6.34668 9.92413C6.89337 9.92392 7.24479 9.3969 7.23828 8.30988C7.23828 7.23587 6.89337 6.689 6.34668 6.68878Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgSkipNext10);
export default ForwardRef;
